import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {CheckboxGroupComponent} from '@brunata-angular/ui';
import {TranslatePipe} from '@brunata-angular/util';

@Component({
    selector: 'app-dismounted-meters-section',
    standalone: true,
    imports: [TranslatePipe, ReactiveFormsModule, CheckboxGroupComponent],
    template: `
        <div class="mb-4">
            <h4 class="fs-6 fw-bold mb-1">
                {{ 'customizedexports_export_dismounted_title' | translate: 'online' : 'export' }}
            </h4>
            <p class="text-muted small mb-2">
                {{ 'customizedexports_export_dismounted_hint' | translate: 'online' : 'export' }}
            </p>
            <div class="border p-3">
                <app-checkbox-group
                    [label]="
                        'customizedexports_export_dismounted_label' | translate: 'online' : 'export'
                    "
                    [description]="
                        'customizedexports_export_dismounted_description'
                            | translate: 'online' : 'export'
                    "
                    [formControl]="control()" />
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DismountedMetersSectionComponent {
    readonly control = input.required<FormControl<boolean>>();
}
